import { render } from "./TaskComponent.vue?vue&type=template&id=1c0daf3e&scoped=true"
import script from "./TaskComponent.vue?vue&type=script&lang=js"
export * from "./TaskComponent.vue?vue&type=script&lang=js"

import "./TaskComponent.vue?vue&type=style&index=0&id=1c0daf3e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c0daf3e"]])

export default __exports__